<template>
  <textarea
    :name="name"
    :id="`form_field_${name}`"
    :required="required"
    :placeholder="placeholder"
    :rows="rows"
    :class="`form_input ${extraClass}`"
    :value="value"
    v-on:input="updateValue($event.target.value)"
    type="text"
  />
</template>

<script>
export default {
  name: 'FormTextarea',
  props: {
    name: {
      default: 'text',
      required: true,
      type: String
    },
    required: {
      default: false,
      required: false,
      type: Boolean
    },
    placeholder: {
      default: '',
      required: false,
      type: String
    },
    value: {
      default: '',
      required: false,
      type: String
    },
    rows: {
      default: '5',
      required: false,
      type: String
    },
    extraClass: {
      default: '',
      required: false,
      type: String
    }
  },

  methods: {
    updateValue(value) {
      this.$emit('input', value)
    }
  }
}
</script>
